(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bio-diagnostic"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const flows = {
      mobilite: [
        { label: 'Douleur qui part du dos vers la jambe', detail: 'Sciatique, nerfs ou engourdissements', result: 'sciatiflex', reason: 'SciatiFlex est la recommandation BIO+ orientée confort nerveux, dos, mobilité et articulations.' },
        { label: 'Gêne musculaire et fatigue physique', detail: 'Tensions, récupération ou crampes', result: 'magneforce', reason: 'Magnéforce 12X accompagne les muscles, le système nerveux et la réduction de la fatigue.' }
      ],
      energie: [
        { label: 'Plus d’énergie et d’endurance', detail: 'Performance et vitalité au quotidien', result: 'triple_maca', reason: 'Triple Maca 3X associe trois variétés de maca dans une routine énergie, endurance et vitalité.' },
        { label: 'Fatigue, stress et manque de tonus', detail: 'Journées intenses ou récupération', result: 'shilajit', reason: 'Shilajit Extra Force est la recommandation BIO+ pour soutenir le tonus, l’endurance et la résistance au quotidien.' }
      ],
      detente: [
        { label: 'Sommeil et détente', detail: 'Difficulté à ralentir ou à récupérer', result: 'magnesium_bisglycinate', reason: 'Le Magnésium Bisglycinate BIO+ est pensé pour une routine de détente, de sommeil et d’équilibre.' },
        { label: 'Fatigue et tensions musculaires', detail: 'Muscles sollicités ou système nerveux', result: 'magneforce', reason: 'Magnéforce 12X accompagne les muscles, le système nerveux et la réduction de la fatigue.' }
      ],
      femme: [
        { label: 'Cycles et équilibre hormonal', detail: 'Routine féminine plus sereine', result: 'inositol', reason: 'BIO+ Inositol+ associe Myo et D-Chiro Inositol, folate et vitamine D dans une routine de bien-être féminin.' },
        { label: 'Imperfections liées au cycle', detail: 'Peau et bien-être féminin', result: 'inositol', reason: 'BIO+ Inositol+ est la recommandation dédiée à l’équilibre hormonal et au bien-être féminin.' }
      ],
      peau: [
        { label: 'Imperfections et peau irrégulière', detail: 'Soutien d’une routine bien-être globale', result: 'noni', reason: 'Noni Bio 4000 mg accompagne la vitalité et l’équilibre général dans une routine quotidienne.' },
        { label: 'Vitalité et équilibre général', detail: 'Une routine simple au quotidien', result: 'noni', reason: 'Noni Bio 4000 mg est la recommandation BIO+ pour accompagner vitalité et bien-être général.' }
      ],
      homme: [
        { label: 'Tonus et vitalité masculine', detail: 'Bien-être masculin au quotidien', result: 'fertilixia', reason: 'Fertilixia BIO+ est pensé pour accompagner le tonus, la vitalité et le bien-être masculin.' },
        { label: 'Énergie et performance', detail: 'Endurance et désir', result: 'triple_maca', reason: 'Triple Maca 3X accompagne l’énergie, l’endurance et la vitalité masculine.' }
      ]
    };

    document.querySelectorAll('[data-bio-diagnostic]').forEach((root) => {
      const steps = [...root.querySelectorAll('[data-step]')];
      const progress = [...root.querySelectorAll('[data-progress]')];
      const priority = root.querySelector('[data-priority-choices]');
      const results = [...root.querySelectorAll('[data-result]')];

      const showStep = (number) => {
        steps.forEach((step) => {
          const active = Number(step.dataset.step) === number;
          step.hidden = !active;
          step.classList.toggle('is-active', active);
        });
        progress.forEach((item) => item.classList.toggle('is-active', Number(item.dataset.progress) <= number));
        root.scrollIntoView({ behavior: 'smooth', block: 'center' });
      };

      root.querySelectorAll('[data-need]').forEach((button) => {
        button.addEventListener('click', () => {
          priority.replaceChildren();
          flows[button.dataset.need].forEach((choice) => {
            const option = document.createElement('button');
            option.type = 'button';
            option.dataset.resultKey = choice.result;
            option.dataset.reason = choice.reason;
            const strong = document.createElement('strong');
            strong.textContent = choice.label;
            const small = document.createElement('small');
            small.textContent = choice.detail;
            option.append(strong, small);
            option.addEventListener('click', () => {
              results.forEach((card) => {
                const active = card.dataset.result === option.dataset.resultKey;
                card.hidden = !active;
                if (active) card.querySelector('[data-reason]').textContent = option.dataset.reason;
              });
              showStep(3);
            });
            priority.append(option);
          });
          showStep(2);
        });
      });

      root.querySelector('[data-back]').addEventListener('click', () => showStep(1));
      root.querySelector('[data-restart]').addEventListener('click', () => {
        results.forEach((card) => card.hidden = true);
        showStep(1);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
